import classNames from 'classnames';
import { forwardRef } from 'react';
import { Controls } from './controls';
import { PrimaryInfo } from './primary_info';
const containerIsControlledCss = "c18cdgtu";
const containerIsInvalidCss = "c136zhzg";
const containerIsDisabledCss = "c1l8xpgm";
const containerCss = "c19djgiz";
const Container = forwardRef((props, ref) => {
  const {
    isControlled,
    isInvalid,
    isDisabled,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsControlledCss]: isControlled,
    [containerIsInvalidCss]: isInvalid,
    [containerIsDisabledCss]: isDisabled
  }, props.className)} />;
});
export const SelectedLocation = ({
  location,
  onEdit,
  onClose,
  isInvalid,
  isDisabled,
  isNewlyAddedLocation,
  ...props
}) => {
  const showControls = !isDisabled && !!onEdit && !!onClose;
  return <Container {...props} isInvalid={isInvalid} isControlled={showControls} isDisabled={isDisabled} data-component="selected-location">
      <PrimaryInfo location={location} />
      {showControls && <Controls isNewlyAddedLocation={isNewlyAddedLocation} onEdit={onEdit} onClose={onClose} />}
    </Container>;
};

require("./selected_location.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./selected_location.js");